import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBInputGroup, MDBModalFooter, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import { editHuntGroup, editUserExternGroup, getGroupUsersPhoneNumbers, getMisc } from "../../../apiclients/streamsapi_bridge";
import SaveChanges from "../../topviews/saveCancel";

import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import AddExterNum from "../../../views/popups/misc/AddExterNum";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import RemoveExternal from "../../../views/popups/misc/RemoveExternal";
import RemoveToUser from "../../../views/popups/misc/RemoveToUser";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import dotsIcon from "../../images/Send_Receive.svg";
import HGSequentialGroup from "./HGSequentialGroup";
import { useAdminContext } from "../../adminstore/Admin-Context";
import ToggleEditWarning from "./ToggleEditWarning";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";

import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy,
    useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";






const UsersAndPhonNumbers = ({ hgcode, isSequentialGroup, isActive, setEdited }) => {
    const { t } = useTranslation();
    const [addUsers, setAddUsers] = useState(false);
    const [selUserAndPhnum, setSelUserAndPhnum] = useState([]);
    const [alreadyExistedUsersAndPhnum, setAlreadyExistedUsersAndPhnum] = useState([]);
    const [removedAdminUsers, setRemovedAdminUsers] = useState([]);
    const [addedAdminUsers, setaddedAdminUsers] = useState([]);
    const [usersUpdated, setUsersUpdated] = useState(false);
    const [message, setMessage] = useState("");
    const [internalError, setInternalError] = useState(false);
    const [AddExternalNumber, setAddExternalNumber] = useState(false)
    const toggleShow15 = () => setAddExternalNumber(!AddExternalNumber);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [updateUsers, setUpdateUsers] = useState([]);
    const [isAddedUsers, setIsAddedUsers] = useState(false);
    const [isdeleteUser, setIsDeleteUser] = useState(false);
    const [sourceUsers, setSourceUsers] = useState([]);
    const [isdelete, setIsDelete] = useState(false);
    const dtogglePopup = () => setIsDelete(!isdelete);
    const [isExtdelete, setIsExtDelete] = useState(false);
    const dExtogglePopup = () => setIsExtDelete(!isExtdelete);
    const [exdetails, setExDetails] = useState({});
    const [exUpdate, setExUpdate] = useState(false);
    const [callerids, setCallerids] = useState([]);
    const [calleridFlag, setCalleridFlag] = useState(true);
    const [externError, setExternError] = useState([]);
    const [isdeleteExt, setIsDeleteExt] = useState(false);
    const [selectDisabled, setSelectedDisabled] = useState([]);
    const [groupUsers, setGroupUsers] = useState([]);
    const [groupExternal, setGroupExternal] = useState([]);
    const [seqGroups, setSeqGroups] = useState([]);
    const [reRender, setReRender] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const [userPhoneDetails, setuserPhoneDetails] = useState([]);
    const [selectedOption, setSelectedOption] = useState(false);
    const [isVoicemailOption, setIsVoicemailOption] = useState(false);
    const [editWarning, seteditWarning] = useState(false);
    const warningToggle = () => seteditWarning(!editWarning);
    const [updateFieldName, setupdateFieldName] = useState("");
    const [updateFieldValue, setupdateFieldValue] = useState("");
    const [toggleValue, settoggleValue] = useState(-1);
    const [emptySequenceIndex, setemptySequenceIndex] = useState([]);
    const [emessage, setEMessage] = useState("");
    const [dynamicFunction, setdynamicFunction] = useState(null);
    const [unSavedWarning, setUnsavedWarning] = useState(false);
    const unsavedWarningToggle = () => setUnsavedWarning(!unSavedWarning);
    const [dynamicDeleteUsers, setdynamicDeleteUsers] = useState([]);
    const streamsProductName = getStreamsProductName();
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

        useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)

    const navigate = useNavigate();

    const addUserRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [searchValue, setSearchValue] = useState(""); // Add search value state
    const [filteredIndices, setFilteredIndices] = useState([]);

    function handleClick() {
        addUserRef.current.click();
    }

    const { register, setValue, formState: { isDirty, dirtyFields, errors }, handleSubmit, reset, getValues, control, watch, setError, unregister, clearErrors } = useForm(
        {
            defaultValues: {
                usrphoneNum: [],
                sequenceGroup: [],
            }
        }
    );
    const { fields, move } = useFieldArray({
        control,
        name: 'usrphoneNum',

    });
    useEffect(() => {
        setSearchValue(""); 
        if (fields && Array.isArray(fields) && fields.length > 0) {
          setFilteredIndices(fields.map((_, index) => index));
        } else {
          setFilteredIndices([]);
        }
      }, [fields.length]);



    // function updateToggles(event, fieldName, value) {
    //     if (value !== '-1') {
    //         setupdateFieldName(fieldName);
    //         setupdateFieldValue(value);
    //         seteditWarning(true);
    //         settoggleValue(value);


    //     }
    // }
    function updateToggles(fieldName, value) {
        fields.forEach((obj, index) => {
            if (watch(`usrphoneNum[${index}].${fieldName}`) !== undefined) {
                if (fieldName !== "is_vm_access" || obj.is_editable) {
                setValue(`usrphoneNum[${index}].${fieldName}`, value, {
                    shouldDirty: true,
                });
                if (obj[fieldName] !== value) {
                    setValue(`usrphoneNum[${index}].positions`, index, { shouldDirty: true });
                } else {
                    unregister(`usrphoneNum[${index}].positions`);
                }
                }
            }
        });
        if (fieldName === "include_ext_num") {
            setSelectedOption(value);
        } else if (fieldName === "is_vm_access") {
            setIsVoicemailOption(value);
        }

    }

    function handleCloseWarning() {
        setSelectedOption("-1");
        warningToggle();
    }

    function handleUpdateToggle() {
        fields.forEach((obj, index) => {
            if (watch(`usrphoneNum[${index}].${updateFieldName}`) !== undefined) {
                setValue(`usrphoneNum[${index}].${updateFieldName}`, updateFieldValue, {
                    shouldDirty: true,
                });
                setValue(`usrphoneNum[${index}].positions`, index, { shouldDirty: true });
            }
        });
        setSelectedOption("-1");
        warningToggle();
    }
    // const onDragEnd = (result) => {
    //     const { destination, source } = result;
    //     console.log(result);
    //     if (!destination) {
    //         return;
    //     }
    //     if (
    //         destination.droppableId === source.droppableId &&
    //         destination.index === source.index
    //     ) {
    //         return;
    //     }
    //     move(source.index, destination.index);
    //     selectedUsers.forEach((user, index) => {
    //         setValue(`usrphoneNum[${index}].new_position`, index, { shouldDirty: true });
    //     })

    // };


    const handleDndKitDragEnd = (event) => {
        const { active, over } = event;
        if (!over) return;

        if (active.id !== over.id) {
            const oldIndex = parseInt(active.id, 10);
            const newIndex = parseInt(over.id, 10);

            move(oldIndex, newIndex);

            selectedUsers.forEach((user, index) => {
                setValue(`usrphoneNum[${index}].new_position`, index, { shouldDirty: true });
            });
        }
    };







  const handleSerach = (value) => {
    setSearchValue(value); // <--- add this

    // Safety check for fields array
    if (!fields || fields.length === 0) {
      setFilteredIndices([]);
      return;
    }
    
    if (!value.trim()) {
      // Show all items when search is cleared
      setFilteredIndices(fields.map((_, index) => index));
      return;
    }
    
    // Use your existing customSearch method
    const filterResult = customSearch(fields, value,  ["name", "extension","userph", "actualNumber", "phNumber"]);
    
    // Find indices of filtered results in original fields array
    const matchingIndices = filterResult.map(filteredItem => 
      fields.findIndex(field => 
        field && ( // Add safety check for field existence
          field.id === filteredItem.id || 
          (field.name === filteredItem.name && field.extension === filteredItem.extension && field.userph === filteredItem.userph  && field.phNumber === filteredItem.phNumber )
        )
      )
    ).filter(index => index !== -1);
    
    setFilteredIndices(matchingIndices);
  };

    let updatedData = [];

    const isFieldDirty = (rowIndex, fieldName) => {
        return dirtyFields?.usrphoneNum?.[rowIndex]?.[fieldName];
    };

    function registerPosition(index, position) {
        const fieldNames = ['is_vm_access', 'include_ext_num', 'cid_pass_flag', 'cid_pass'];
        const isVmDirty = isFieldDirty(index, 'is_vm_access');
        const isIncludeExtDirty = isFieldDirty(index, 'include_ext_num');
        const isCidFlagDirty = isFieldDirty(index, 'cid_pass_flag');
        const isPassDirty = isFieldDirty(index, 'cid_pass');

        console.log("is_vm_access ::: " + isVmDirty);
        console.log("isincludeextDirty ::: " + isIncludeExtDirty);
        console.log("iscidflagDirty ::: " + isCidFlagDirty);
        console.log("ispassDirty ::: " + isPassDirty);

        // If ANY of the fields are dirty, keep the position

        if (isVmDirty || isIncludeExtDirty || isCidFlagDirty || isPassDirty) {
            setValue(`usrphoneNum[${index}].positions`, position, { shouldDirty: true });
        } else {
            // Only unregister if NONE of the fields are dirty
            unregister(`usrphoneNum[${index}].positions`);
        }
    }

    // fields && fields.length > 0 && fields.forEach((infoObj, index) => {
        if (fields && fields.length > 0 && filteredIndices.length > 0) {
            filteredIndices.forEach((originalIndex) => {
              const infoObj = fields[originalIndex];
              
              // Additional safety check for the individual field object
              if (!infoObj || typeof infoObj !== 'object') return;
              
        let cidPassVal = infoObj.cid_pass;
        // Build the data object
        let phNumber = infoObj.userph.length > 5 ? formattedNumber(infoObj.userph)  + "" : infoObj.userph ?? ""
        let rowData = {
            name: infoObj.name,
            // userph: infoObj.userph + "" ?? "",
            actualNumber : phNumber?.toString().replace(/[ ]/g, ''),
            userph : phNumber,
            value: infoObj.uniqueid ?? "",
            extension: infoObj.extension ?? "",
            index: infoObj.position,
            voicemail: (<>
                {infoObj.uniqueid && infoObj.uniqueid.indexOf("@") !== -1 && (
                    <div className="phoneselect d-flex align-items-center justify-content-center flex-row w-100">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <label
                                className={`big-checkbox ${!infoObj.is_editable && "disabled"} ${watch(`usrphoneNum[${originalIndex}].is_vm_access`)
                                    ? "checked"
                                    : ""
                                    }`}
                            >
                                <input
                                    type="checkbox"
                                    checked={watch(`usrphoneNum[${originalIndex}].is_vm_access`)}
                                    value={watch(`usrphoneNum[${originalIndex}].is_vm_access`)}
                                    disabled={!infoObj.is_editable}
                                    onChange={(e) => {
                                        setValue(`usrphoneNum[${originalIndex}].is_vm_access`, e.target.checked, { shouldDirty: true });
                                        registerPosition(originalIndex, infoObj.position);
                                    }}
                                />
                                <span className="box">
                                    <svg
                                        className="checkmark"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                                            fill="#FFFFFF"
                                        />
                                    </svg>
                                </span>
                            </label>
                        </div>

                    </div>

                )}
            </>),

            callerID: (
                <>
                    {isSequentialGroup !== 3 && (watch(`usrphoneNum[${originalIndex}].include_ext_num`) !== undefined) && infoObj.uniqueid && infoObj.uniqueid.indexOf("@") !== -1 && (
                        <div className="phoneselect d-flex align-items-center justify-content-center flex-row w-100">
                            {/* <label className="switch">
                                <input
                                    className="form-control"
                                    type="checkbox"
                                    // disabled={!watch(`usrphoneNum[${index}].include_toggle_display`)}
                                    checked={watch(`usrphoneNum[${index}].include_ext_num`)}
                                    value={watch(`usrphoneNum[${index}].include_ext_num`)}
                                    onChange={(e) => {
                                        setValue(`usrphoneNum[${index}].include_ext_num`, e.target.checked, { shouldDirty: true });
                                        setValue(`usrphoneNum[${index}].positions`, infoObj.position, { shouldDirty: true });
                                    }}
                                />
                                <span className="slider round"></span>
                            </label> */}
                            {/* <label class="custom-checkbox">
                                <input
                                    type="checkbox"
                                    checked={watch(`usrphoneNum[${index}].include_ext_num`)}
                                    value={watch(`usrphoneNum[${index}].include_ext_num`)}
                                    onChange={(e) => {
                                        setValue(`usrphoneNum[${index}].include_ext_num`, e.target.checked, { shouldDirty: true });
                                        setValue(`usrphoneNum[${index}].positions`, infoObj.position, { shouldDirty: true });
                                    }}
                                />
                                <span class="checkmarkNew"></span>
                            </label> */}
                            <div className="d-flex align-items-center justify-content-center w-100">
                                <label
                                    className={`big-checkbox ${watch(`usrphoneNum[${originalIndex}].include_ext_num`)
                                        ? "checked"
                                        : ""
                                        }`}
                                >
                                    <input
                                        type="checkbox"
                                        checked={watch(`usrphoneNum[${originalIndex}].include_ext_num`)}
                                        value={watch(`usrphoneNum[${originalIndex}].include_ext_num`)}
                                        onChange={(e) => {
                                            setValue(`usrphoneNum[${originalIndex}].include_ext_num`, e.target.checked, { shouldDirty: true });
                                            registerPosition(originalIndex, infoObj.position);
                                        }}
                                    />
                                    <span className="box">
                                        <svg
                                            className="checkmark"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                                                fill="#FFFFFF"
                                            />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                        </div>
                    )}
                </>
            ),

            callerIDPass: (
                <>
                    {((infoObj.uniqueid && infoObj.uniqueid.indexOf("@") !== -1 && (watch(`usrphoneNum[${originalIndex}].include_ext_num`)) && watch(`usrphoneNum[${originalIndex}].include_toggle_display`) && isSequentialGroup !== 3) || (infoObj.uniqueid.indexOf("@") === -1)) && (
                        // {(watch(`usrphoneNum[${index}].include_ext_num`) === undefined || watch(`usrphoneNum[${index}].include_toggle_display`)) && (
                        <div className="d-flex align-items-center">
                            <div className='d-flex align-items-center'>
                                <div className="tel-numbers fw-bold me-3">{t("CallerIDpasstrough")}</div>
                                <input
                                    type="checkbox"
                                    name='checkNoLabel'
                                    id='checkboxNoLabel'
                                    checked={watch(`usrphoneNum[${originalIndex}].cid_pass_flag`)}
                                    value={watch(`usrphoneNum[${originalIndex}].cid_pass_flag`)}
                                    onChange={(e) => {
                                        setValue(`usrphoneNum[${originalIndex}].cid_pass_flag`, e.target.checked, { shouldDirty: true });
                                        registerPosition(originalIndex, infoObj.position);
                                        clearErrors(`usrphoneNum.${infoObj.position}.cid_pass`);
                                    }}
                                />
                            </div>
                            <div className="ms-2 w-40">
                                <select
                                    className="form-select w-100"
                                    name="Default"
                                    disabled={watch(`usrphoneNum[${originalIndex}].cid_pass_flag`)}
                                    value={watch(`usrphoneNum[${originalIndex}].cid_pass`)}
                                    onChange={(e) => {
                                        setValue(`usrphoneNum[${originalIndex}].cid_pass`, e.target.value, { shouldDirty: true });
                                        setValue(`usrphoneNum[${originalIndex}].positions`, infoObj.position, { shouldDirty: true });
                                        clearErrors(`usrphoneNum.${infoObj.position}.cid_pass`);
                                    }}
                                >
                                    <option value="0">Choose Caller ID...</option>
                                    {callerids && callerids.length > 0 && callerids.map((item) => (
                                        <option key={item.phnum} value={item.phnum}>
                                            {item.addl_info}
                                        </option>
                                    ))}
                                </select>
                                {errors?.usrphoneNum?.[infoObj.position]?.cid_pass && (

                                    <p className="text-danger">
                                        {errors.usrphoneNum[infoObj.position].cid_pass.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                </>
            ),

            delete: (
                <div className="ms-4 w-40">
                    <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
                        <MDBIcon onClick={(e) => deleteSelectedUser(e, [infoObj], 0)} icon="times" color="primary" />
                    </div>
                </div>
            )
        };
        if (isSequentialGroup === 2) {
            rowData['order'] = (
                <>
                    <div className="w-100">
                        <img src={dotsIcon} className="link-icon" />
                        {originalIndex + 1}
                    </div>
                </>
            );
        }
        updatedData.push(rowData);
    });
        }
    const basicData = {
        columns: [
            ...(isSequentialGroup === 2
                ? [{
                    label: (
                        <>
                            <p className="fw-bold">Order</p>
                            {isSequentialGroup === 2 &&
                                <p>
                                    &nbsp;
                                </p>
                            }
                        </>

                    ), field: "order"
                }]
                : []
            ),
            {
                label: (
                    <>
                        <p className="fw-bold">Name</p>
                        {isSequentialGroup === 1 || isSequentialGroup === 2 &&
                            <p>
                                &nbsp;
                            </p>
                        }
                    </>
                ), field: "name"
            },
            {
                label: (
                    <>
                        <p className="fw-bold">Extension or Number</p>
                        {isSequentialGroup === 1 || isSequentialGroup === 2 &&

                            <p>
                                &nbsp;
                            </p>
                        }
                    </>
                ), field: "userph"
            },
            {
                label: (
                    <>
                        <p className="fw-bold text-center">Show Voicemail in {streamsProductName} <MDBIcon fas icon="info-circle" className="ms-2 cursor-pointer ShowVoicemailTooltip"/></p>
                        <div className="d-flex align-items-center justify-content-center mt-2">
                            <label
                                className={`big-checkbox ${isVoicemailOption
                                    ? "checked"
                                    : ""
                                    }`}
                            >
                                <input
                                    type="checkbox"
                                    checked={isVoicemailOption}
                                    onChange={(e) => {
                                        if (e) {
                                            // setSelectedCallMonitor(true);
                                            updateToggles("is_vm_access", e.target.checked);
                                        }
                                    }}
                                />
                                <span className="box">
                                    <svg
                                        className="checkmark"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                                            fill="#FFFFFF"
                                        />
                                    </svg>
                                </span>
                            </label>
                        </div>
                    </>
                ), field: "voicemail",
                sort: false
            },
            ...(isSequentialGroup !== 3
                ? [
                    {
                        label: (
                            <>
                                <p className="fw-bold text-center">Include User's External Numbers</p>
                                {/* <div className="three-checkbox round2 mx-0">
                                    <input
                                        type="radio"
                                        name="UsersExternalNumbers"
                                        checked={selectedOption === false}
                                        onChange={(e) => {
                                            setSelectedOption(false);
                                            updateToggles(e, 'include_ext_num', false);
                                        }}
                                    />
                                    <input
                                        type="radio"
                                        name="UsersExternalNumbers"
                                        checked={selectedOption === "-1"}
                                        onChange={(e) => {
                                            setSelectedOption("-1");
                                            updateToggles(e, 'include_ext_num', '-1');
                                        }}
                                    />
                                    <input
                                        type="radio"
                                        name="UsersExternalNumbers"
                                        checked={selectedOption === true}
                                        onChange={(e) => {
                                            setSelectedOption(true);
                                            updateToggles(e, 'include_ext_num', true);
                                        }}
                                    />
                                    <span className="slider"></span>
                                </div> */}
                                {/* <label class="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={selectedOption}
                                        onChange={(e) => {
                                            if (e) {
                                                // setSelectedCallMonitor(true);
                                                updateToggles("include_ext_num", e.target.checked);
                                            }
                                        }}
                                    />
                                    <span class="checkmarkNew"></span>
                                </label> */}
                                <div className="d-flex align-items-center justify-content-center mt-2">
                                    <label
                                        className={`big-checkbox ${selectedOption
                                            ? "checked"
                                            : ""
                                            }`}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedOption}
                                            onChange={(e) => {
                                                if (e) {
                                                    // setSelectedCallMonitor(true);
                                                    updateToggles("include_ext_num", e.target.checked);
                                                }
                                            }}
                                        />
                                        <span className="box">
                                            <svg
                                                className="checkmark"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                                                    fill="#FFFFFF"
                                                />
                                            </svg>
                                        </span>
                                    </label>
                                </div>
                            </>
                        ),
                        field: "callerID",
                        sort: false
                    }
                ]
                : []
            ),
            ...(isSequentialGroup !== 3 ? [
                { label: " ", field: "callerIDPass", sort: false }] : []),
            {
                label: (
                    <>
                        <p className="fw-bold">Remove</p>
                        {isSequentialGroup === 1 || isSequentialGroup === 2 &&
                            <p>
                                &nbsp;
                            </p>
                        }
                    </>
                ), field: "delete", sort: false
            }
        ],
        rows: updatedData
    };


    async function getUserPhoneNumbers() {
        try {
            setIsloading(true);
            const response = await getGroupUsersPhoneNumbers(JSON.parse(sessionStorage.getItem("admin_session")).siteid, hgcode);
            setTimeout(() => { setIsloading(false) }, 1000);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            let rawData = await response.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            let userPHList = [];

            // if (rawData?.members?.users && rawData.members.users.length > 0) { 
            if (rawData?.members?.users) {  //The code runs even if the array is empty ([]).
                userPHList = [...rawData.members.users];
                setGroupUsers(rawData.members.users);
            }
            if (rawData?.members?.ext_num && rawData.members.ext_num.length > 0) {
                userPHList = [...userPHList, ...rawData.members.ext_num];
                setGroupExternal(rawData.members.ext_num);

            }
            setSeqGroups((rawData?.members?.seq_groups && rawData.members.seq_groups.length > 0) ? rawData.members.seq_groups : []);

            if (userPHList.length >= 0) {

                const updateValue = userPHList.map((user) => {
                    const updatedUser = { ...user };

                    // Set userph based on the conditions
                    if (user.extension) {
                        updatedUser.userph = user.extension;
                    } else {
                        updatedUser.userph = user.uniqueid ?? "";
                    }
                    updatedUser.phNumber = formattedNumber(user.uniqueid) ?? "";
                    updatedUser.actualNumber = updatedUser.phNumber.replace(/[ ]/g, '');
                    updatedUser.cid_pass_flag = (user.cid_pass_flag === undefined || user.cid_pass_flag === 1) ? true : false;
                    updatedUser.include_ext_num = (user.include_ext_num === undefined || user.include_ext_num === 0) ? false : true;
                    // Set cid_pass to 0 if it doesn't exist
                    updatedUser.cid_pass = user.cid_pass || "0";

                    return updatedUser;
                });
                const sortValue = updateValue.sort((a, b) => a.position - b.position);
                console.log(JSON.stringify(sortValue) + "  initial  value");
                setSelectedUsers(sortValue);

                const flagUpdate = sortValue.map((infoObj) => infoObj.cid_pass_flag);
                console.log("update value  " + JSON.stringify(flagUpdate));
                setSelectedDisabled(flagUpdate);
                setuserPhoneDetails(sortValue);
                setSelectedOption(false);
                setIsVoicemailOption(false);
                reset({
                    usrphoneNum: sortValue
                });
                setDataLoaded(true);

            }
            // setReRender(false);


        } catch (e) {
            console.log(`Unable to load the sepcific group info:${e}`);
        }
    }


    useEffect(() => {
        if (((hgcode && hgcode != "") || reRender) && isActive) {
            setReRender(false);
            getUserPhoneNumbers();
        }
    }, [hgcode, reRender, isActive]);

    useEffect(() => {
        setEdited(isDirty);
    }, [isDirty]);
    const isdirtyFields =
        Object.keys(dirtyFields).length === 0 ? false : true;
    const onSaveChanges = async (data) => {
        try {
            let result = {};
            if (isDirty) {


                const seqDirtyFields = dirtyFields["sequenceGroup"];
                let seqData = data["sequenceGroup"];
                const seqGroups = {};
                const editMembers = [];
                if (seqDirtyFields) {

                    console.log("seqDirtyFields ::::::::::: " + JSON.stringify(seqDirtyFields));
                    console.log("seqData ::::::::::: " + JSON.stringify(seqData));


                    const emptySequence = seqData.filter((seq) => seq.userphone.length === 0).map((seq) => (parseInt(seq.seq.replace(/\D/g, ""), 10) + 1));
                    if (emptySequence?.length > 0) {
                        setemptySequenceIndex(emptySequence);
                        setEMessage(`You have created the sequence(s), but a user/external number has not been added. Please include a user/external number in the sequence(s) and try again.`);
                        return;
                    }
                    const addMembers = [];
                    seqData.forEach((sequence, index) => {

                        sequence.userphone.forEach((member) => {

                            const dirtyFieldsForMember = seqDirtyFields[index]?.userphone?.find((item) => item.isNewMember) || {};
                            const isDirtyMember = member.isNewMember;

                            if (isDirtyMember) {
                                const modifiedMember = { ...member, seq: parseInt(sequence.seq.slice(-1)) };

                                modifiedMember.ring_secs = parseInt(sequence.ring_secs);

                                delete modifiedMember.user_num_id;
                                delete modifiedMember.isNewMember;
                                delete modifiedMember.title;
                                delete modifiedMember.extension_number;
                                addMembers.push(modifiedMember);
                            }
                        });
                        if (sequence.oldseq === "") {
                            const prevInfo = seqGroups?.add_seq?.add_members ?? [];
                            seqGroups.add_seq = { add_members: [...prevInfo, ...addMembers] };
                        } else {
                            if (addMembers.length > 0) {
                                const prevInfo = seqGroups?.edit_seq?.add_members ?? [];
                                seqGroups.add_seq = { add_members: [...prevInfo, ...addMembers] };
                            }
                            if (sequence.isEdited && seqDirtyFields[index]?.ring_secs && !(data.delete_Seq && data.delete_Seq.includes(sequence.oldseq.slice(-1)))) {
                                editMembers.push({ ring_secs: parseInt(sequence.ring_secs), seq: parseInt(sequence.oldseq.slice(-1)) });
                            }
                        }
                    });

                    if (data.delete_user_num_id && data.delete_user_num_id.length > 0) {
                        const deleteDeviceId = data.delete_user_num_id.filter(id => !(data.delete_Seq && data.delete_Seq.includes(parseInt(id.split("_")[1]))));
                        const deleteid = [];
                        deleteDeviceId.map(ids => deleteid.push(parseInt(ids.split("_")[0])));
                        if (deleteid.length > 0) {
                            seqGroups.edit_seq = { ...seqGroups?.edit_seq, delete_members: deleteid };
                        }
                    }

                    if (editMembers.length > 0) {
                        seqGroups.edit_seq = { ...seqGroups?.edit_seq, edit_members: editMembers };
                    }

                    if (data.delete_Seq && data.delete_Seq.length > 0) {
                        seqGroups.delete_seq = data.delete_Seq;
                    }
                    if (Object.keys(seqGroups).length > 0) {
                        result = {
                            seq_groups: seqGroups
                        }
                    }
                }

                console.log("final sequence info: ", JSON.stringify(seqGroups));

                const dirtyFieldsArray = dirtyFields["usrphoneNum"];
                const dataFieldsArray = data["usrphoneNum"];
                const modifiedRows = [];
                if (dirtyFieldsArray) {
                    for (let i = 0; i < dirtyFieldsArray.length; i++) {
                        console.log(dirtyFieldsArray[i]);
                        if (!dirtyFieldsArray[i]) {
                            continue;
                        }
                        const modifiedFields = {};
                        if (dirtyFieldsArray[i].positions) {
                            const dirtyFieldNames = dirtyFieldsArray[i];

                            Object.entries(dirtyFieldNames).map(([key, value]) => {
                                if (data.usrphoneNum[i]?.hasOwnProperty(key)) {
                                    if (key !== "name" && key !== "extension" && key !== "include_toggle_display" && key !== "userph")
                                        modifiedFields[key] = data.usrphoneNum[i][key];
                                }
                            });
                        }
                        if (Object.keys(modifiedFields).length > 0 || dirtyFieldsArray[i].new_position) {
                            modifiedFields.positions = data.usrphoneNum[i].position;
                            modifiedFields.uniqueid = data.usrphoneNum[i].uniqueid;
                            if (dirtyFieldsArray[i].new_position) {
                                modifiedFields.new_position = data.usrphoneNum[i].new_position;
                            }
                        }


                        if (Object.keys(modifiedFields).length > 0) {
                            modifiedRows.push(modifiedFields)

                        }
                    }
                }

                const modifiedArray = modifiedRows && modifiedRows.length > 0 && modifiedRows.map(obj => {
                    // Create a new object with the desired modifications
                    const { positions, ...rest } = obj; // Remove old field names
                    return { ...rest, position: positions };
                });



                let usersArray = [];
                let extNumArray = [];

                modifiedArray && modifiedArray.length > 0 && modifiedArray.forEach(item => {
                    if (item && Object.keys(item).length > 0) {
                        if (item.uniqueid.includes('@')) {
                            usersArray.push({ ...item });
                        } else {
                            extNumArray.push({ ...item });
                        }
                    }
                });
                if (usersArray.length > 0) {
                    result.users = {
                        update_users: usersArray
                    };
                }

                if (extNumArray.length > 0) {
                    result.ext_num = {
                        update_ext_num: extNumArray
                    };
                }

                // alert("final value is ::::::::::: " + JSON.stringify(result));
                if (Object.keys(result).length > 0) {
                    setIsloading(true);

                    let updateObj = {
                        members: result,
                    }
                    updateObj.reqid = 9;
                    updateObj.siteid = JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid;
                    updateObj.code = hgcode;
                    console.log("final value is ::::::::::: " + JSON.stringify(updateObj));

                    let saverep = await editHuntGroup(updateObj);
                    setIsloading(false);
                    console.log(saverep);
                    let saverepeMsg = await saverep.json();
                    console.log("reponse from user and external number ::::::::::: " + JSON.stringify(saverepeMsg));

                    if (saverepeMsg.status && saverepeMsg.status == "success") {
                        setMessage(saverepeMsg.message);
                        setUsersUpdated(true);
                        setReRender(true);
                    } else {
                        if (saverepeMsg.message?.errors) {
                            saverepeMsg.message.errors.forEach((err) => {
                                if (err.param_name.indexOf("ring_secs") !== -1) {
                                    const param_name = err.param_name.indexOf("ring_secs") !== -1 && err.position ? `sequenceGroup.${err.position}.ring_secs` : null;
                                    if (param_name) {
                                        setError(param_name, {
                                            type: "server",
                                            message: err.message,
                                        });
                                    }
                                } else if (err.param_name.indexOf("cid_pass") !== -1) {
                                    const param_name = err.param_name.indexOf("cid_pass") !== -1 && err.position !== undefined ? `usrphoneNum.${err.position + ""}.cid_pass` : null;
                                    if (param_name) {
                                        setError(param_name, {
                                            type: "server",
                                            message: err.message,
                                        });
                                    }

                                }

                                else {
                                    // setError(err.param_name, {
                                    //     type: "server",
                                    //     message: err.message,
                                    // });
                                    if (err.message) {
                                        // let message = err.message;
                                        // const dynamicMessage = message.split("user(s) ")[1].split(" has to present")[0];
                                        // const firstMessage = message.split(dynamicMessage)[0];
                                        // const lastMessage = message.split(dynamicMessage)[1];


                                        // message = (
                                        //     <>
                                        //         {firstMessage} <strong>{dynamicMessage}</strong> {lastMessage}
                                        //     </>
                                        // );
                                        // console.log("message ::::::::::: " + message);
                                        // setEMessage(message);
                                        setEMessage(err.message);

                                    }


                                }
                            });
                        }
                    }
                }

            }
        } catch (e) {
            console.log(`Error ::: ${e}`);
            console.error(e.stack);
            setInternalError(true);
        }
    }

    const closeTogglePopup = (flag) => {
        if (isDirty && flag === 0) {
            setdynamicFunction(() => () => closeTogglePopup(1));
            unsavedWarningToggle();

        } else {
            setAddUsers(!addUsers);
        }
    }

    useEffect(() => {
        async function fetchData() {
            let UserList = [], apiResponse = {};
            apiResponse = await getMisc(JSON.parse(sessionStorage.getItem("admin_session")).siteid, { misc: ["hunt_users"], code: hgcode });
            console.log(`Hunt Free UserList ::::: ${JSON.stringify(apiResponse)}`);
            if (apiResponse.status === 200) {
                UserList = await apiResponse.json();

                UserList = UserList.misc.users;
                // alert(JSON.stringify(UserList));
                setSourceUsers(UserList);
            } else {
            }
        }

        if (hgcode && hgcode.code != "" && isActive) {
            fetchData();
        }


    }, [hgcode, isActive, reRender]);

    function deleteSelectedUser(event, usrObj, flag) {
        event?.preventDefault();
        event?.stopPropagation();

        if (isDirty && flag === 0) {
            unsavedWarningToggle();
            setdynamicDeleteUsers([...usrObj])
            setdynamicFunction(() => () => deleteSelectedUser(null, usrObj, 1));

        } else {
            setUpdateUsers([...usrObj]);
            if (usrObj.length > 0 && usrObj[0].extension) {
                dtogglePopup();
            } else {
                dExtogglePopup();

            }
        }
    }


    useEffect(() => {
        if (exdetails && exUpdate) {
            sendExternalApiReq(exdetails);

        }

    }, [exdetails, exUpdate]);

    async function sendExternalApiReq(data) {
        let updateObj = {
            reqid: 47,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            code: hgcode,
            members: {
                ext_num: {
                    create_ext_num: {
                        ...data,
                    }
                }
            }
        }
        // alert("Request ::::::::: "+JSON.stringify(updateObj));

        let saverep = await editUserExternGroup(updateObj);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        // alert("response for external :::::: "+JSON.stringify(saverepeMsg));
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            setMessage(saverepeMsg.message);
            setUsersUpdated(true);
            // data.userph = data.uniqueid;
            // data.cid_pass_flag = data.cid_pass_flag ?? true;
            // data.cid_pass = data.cid_pass ?? 0;
            // data.position = saverepeMsg?.members?.ext_num[0]?.position ?? -1;
            // const addNewExtern = [...selectedUsers, data];

            // setGroupExternal(prev => [...prev, data]);
            // setSelectedUsers(addNewExtern);
            // reset({
            //     usrphoneNum: addNewExtern
            // });
            // setMessage(`External Number ${data.uniqueid} added successfully.`);
            setUsersUpdated(true);
            toggleShow15();
            setExUpdate(false);
            setExDetails({});
            setReRender(true);

        } else if (saverepeMsg.message?.errors) {
            setExUpdate(false);
            setExDetails({});
            setExternError(saverepeMsg.message.errors);
        }
    }

    async function getCallerIds() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["callerid_list"] }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
            //navigate("/");
        }
        //alert(`calerid list ::::::::: ${JSON.stringify(tdata?.misc?.callerid_list) }`);
        setCallerids(tdata?.misc?.callerid_list ?? []);

    }

    useEffect(() => {
        if (isActive) {
            getCallerIds();
        }
    }, [isActive]);


    function checkDataModified() {
        if (addedAdminUsers?.length !== 0 || removedAdminUsers?.length !== 0) {
            if (removedAdminUsers?.length > 0 || alreadyExistedUsersAndPhnum?.length !== addedAdminUsers?.length) {
                setValue("addedUsers", addedAdminUsers, { shouldDirty: true });
                setValue("removedUsers", removedAdminUsers, { shouldDirty: true });
            } else {
                let listAgents = alreadyExistedUsersAndPhnum.map(obj => obj.agentid);
                for (let index = 0; index < addedAdminUsers?.length; index++) {
                    if (!listAgents.includes(addedAdminUsers[index].agentid)) {
                        setValue("addedUsers", addedAdminUsers, { shouldDirty: true });
                        setValue("removedUsers", removedAdminUsers, { shouldDirty: true });
                        break;
                    }
                }
            }
        }
    }

    const onCloseChanges = () => {
        // processUserDtlsFraming(alreadyExistedUsersAndPhnum);
        setSelectedOption("-1");
        setEMessage("");
        resetHookForm();
    }

    const resetHookForm = () => {
        setRemovedAdminUsers([]);
        setaddedAdminUsers([]);
        reset();
        setReRender(true);
    }

    useEffect(() => {
        if (updateUsers.length > 0 && isdeleteExt) {
            deleteExternalNum();
            setIsDeleteExt(false);
        } {

        }

    }, [isdeleteExt, updateUsers])


    async function deleteExternalNum() {
        const usernames = new Set(updateUsers.map(item => item.name));
        const phnum = new Set(updateUsers.map(item => item.value));
        const deleteArray = updateUsers.map(item => {
            return {
                position: item.position,
                uniqueid: item.uniqueid
            }
        })

        const users = Array.from(usernames).join(', ');
        let updateObj = {
            reqid: 9,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            code: hgcode,
            members: {
                ext_num: {
                    delete_ext_num: deleteArray,
                }
            }
        }
        // alert(JSON.stringify(updateObj));
        let saverep = await editHuntGroup(updateObj);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            // const filterNum = new Set(updateUsers.map(item => item.uniqueid));
            // const filterUsers = selectedUsers.filter((item) => !filterNum.has(item.uniqueid));
            // const filtergroupEx = groupExternal.filter((item) => !filterNum.has(item.uniqueid));

            // setGroupExternal(filtergroupEx);
            // setSelectedUsers(filterUsers);
            // reset({
            //     usrphoneNum: filterUsers
            // });
            // setDisableEffect(true);
            setUsersUpdated(true);
            setMessage(
                `External Number(s) ${users} removed successfully.`
            );
            setReRender(true);
        } else {

        }


    }



    useEffect(() => {
        if (updateUsers.length > 0 && isAddedUsers) {
            updateTheUser("add_users");
            setIsAddedUsers(false);
        }
    }, [updateUsers, isAddedUsers]);

    useEffect(() => {
        if (updateUsers.length > 0 && isdeleteUser) {
            updateTheUser("remove_users");
            setIsDeleteUser(false);
        }
    }, [updateUsers, isdeleteUser]);

    async function updateTheUser(fieldName) {
        const agentids = new Set(updateUsers.map(item => item.agentid));
        let update = {}


        let saverep;
        if (fieldName === "add_users") {
            update = {
                reqid: 47,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                code: hgcode,
                members: {
                    users: {
                        [fieldName]: Array.from(agentids),

                    }
                }
            };
            // alert("Request ::::::::: "+JSON.stringify(update))
            console.log(JSON.stringify(update));
            saverep = await editUserExternGroup(update);
        } else {
            const deleteUsers = updateUsers.map(item => {
                return {
                    uniqueid: item.uniqueid,
                    position: item.position,
                }
            })

            update = {
                reqid: 9,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                code: hgcode,
                members: {
                    users: {
                        [fieldName]: deleteUsers,

                    }
                }
            };
            saverep = await editHuntGroup(update);

        }
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        //  alert(JSON.stringify(saverepeMsg));
        const usernames = new Set(updateUsers.map(item => item.name));
        const users = Array.from(usernames).join(', ');
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            //debugger;
            if (fieldName === "add_users") {

                // const newRecord = updateUsers.map(item => {
                //     const matchExtension = saverepeMsg.members.users.find(member => member.extension === item.extension);
                //     if (matchExtension) {
                //         return {
                //             ...item,
                //             userph: item.extension,
                //             cid_pass_flag: true,
                //             cid_pass: 0,
                //             position: matchExtension.position,
                //             include_toggle_display: matchExtension.include_toggle_display,
                //             include_ext_num: false,
                //             uniqueid: matchExtension.uniqueid
                //         }

                //     }

                // })
                // const updatedUsers = [...selectedUsers, ...newRecord]
                // setGroupUsers(prev => [...prev, ...newRecord]);
                // setSelectedUsers(updatedUsers);
                // reset({
                //     usrphoneNum: updatedUsers
                // });

                // data.userph = data.uniqueid;
                // data.cid_pass_flag = data.cid_pass_flag ?? true;
                // data.cid_pass = data.cid_pass ?? 0;
                // setDisableEffect(true);
                //processUserDtlsFraming(updatedUsers);
                setMessage(`User(s) ${users} added successfully.`);
                // setUsersUpdated(true);

            } else {
                // const filterExtension = new Set(updateUsers.map(item => item.extension));
                // const filterUsers = selectedUsers.filter((item) => !filterExtension.has(item.extension));
                // const filterGroupUsers = groupUsers.filter((item) => !filterExtension.has(item.extension));
                // setGroupUsers(filterGroupUsers);
                // setSelectedUsers(filterUsers);
                // if (filterUsers.length === 0) {
                //     const currentValues = getValues();
                //     reset({
                //         ...currentValues,
                //         usrphoneNum: filterUsers,
                //     });
                //     setSelUserAndPhnum([]);
                // } else {
                //     reset({
                //         usrphoneNum: filterUsers
                //     });
                // }

                // setUsersUpdated(true);
                setMessage(
                    `User(s) ${users} removed successfully.`
                );
            }
            setUsersUpdated(true);
            setReRender(true);
        } else {
            if (fieldName === "remove_users") {
                const filterExtension = new Set(updateUsers.map(item => item.extension));
                let modifyUser = selectedUsers.filter((item) => !filterExtension.has(item.extension));
                let modifyGroupUser = groupUsers.filter((item) => !filterExtension.has(item.extension));
                modifyGroupUser = [...modifyGroupUser, ...updateUsers];
                modifyUser = [...modifyUser, ...updateUsers];
                setGroupUsers(modifyGroupUser);
                setSelectedUsers(modifyUser);
                reset((prev) => ({
                    ...prev,
                    usrphoneNum: modifyUser
                }));
                //rocessUserDtlsFraming(modifyUser);
                // setDisableEffect(true);
                setInternalError(true);
            }
        }
    }

    useEffect(() => {
        checkDataModified();
    }, [addedAdminUsers, alreadyExistedUsersAndPhnum, removedAdminUsers, selUserAndPhnum]);

    // const getListStyle = (isDraggingOver) => ({

    // });

    // const getItemStyle = (isDragging, draggableStyle) => ({
    //     userSelect: "none",
    //     ...draggableStyle,
    // });

    const handleAddExternalNumber = (flag) => {
        if (isDirty && flag === 0) {
            setdynamicFunction(() => () => handleAddExternalNumber(1));
            unsavedWarningToggle();

        } else {
            setExternError([])
            toggleShow15();
        }
    }

    const handleUnsavedOk = async () => {
        unsavedWarningToggle();
        await getUserPhoneNumbers();
        if (dynamicFunction) {
            dynamicFunction(null, dynamicDeleteUsers.length > 0 ? dynamicDeleteUsers : [], 1);
            setdynamicFunction(null);
        }


    }

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 5 },
        })
    );




    function SortableItem({ id, row, columns }) {
        const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition,
            isDragging,
        } = useSortable({ id });

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            opacity: isDragging ? 0.8 : 1,
            cursor: 'grab',
        };

        return (
            <tr
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
                className="sortable-row"
            >
                {columns.map((column) => (
                    <td key={column.field} className="HuntGroup">
                        {row[column.field]}
                    </td>
                ))}
            </tr>
        );
    }






    return (
        <>
            {isSequentialGroup === 3 && (
                <HGSequentialGroup
                    seqGroups={seqGroups}
                    register={register}
                    control={control}
                    errors={errors}
                    setError={setError}
                    setValue={setValue}
                    getValues={getValues}
                    reset={reset}
                    groupcode={hgcode}
                    watch={watch}
                    clearErrors={clearErrors}
                    setemptySequenceIndex={setemptySequenceIndex}
                    emptySequenceIndex={emptySequenceIndex}
                    setEMessage={setEMessage}
                    emessage={emessage}
                    userPhoneDetails={userPhoneDetails}
                />
            )}
            <div className="d-flex justify-content-between">
                {isSequentialGroup === 3 && (
                    <div className="general-settings mb-4">
                        {t("users_Phone_Numbers")}
                    </div>
                )}
                {isSequentialGroup === 2 && (
                    <div style={{ width: "306px" }}>
                        <MDBInputGroup className="w-100" textAfter={<MDBIcon fas icon="search" />}>
                            <input
                                type="text"
                                className="form-control w-100"
                                 ref={searchRef}
                                placeholder="Search"
                                value={searchValue}
                                onChange={(e) => {
                                    setSearchInput(e.target.value);
                                    handleSerach(e.target.value);
                                }}
                            />
                        </MDBInputGroup>
                    </div>
                )}


                <div className={`button_aligniment_External ${isSequentialGroup !== 3 ? 'w-100' : ''}`}>
                    <div className="ExternalNumber" >
                        <div className="float-end d-flex">

                            <MDBBtn className="btn btn-primary green-button display-inline float-right me-2"
                                onClick={(e) => closeTogglePopup(0)}>
                                <MDBIcon fas icon="plus" size="sm" /> {t('addusers')}
                            </MDBBtn>
                            <MDBBtn className="btn btn-primary float-right" onClick={(e) => handleAddExternalNumber(0)}>
                                <MDBIcon fas icon="plus" size="sm" /> {t("addExternal")}
                            </MDBBtn>
                        </div>
                    </div>
                </div>

            </div>

            {/* <form> */}
            {isSequentialGroup === 2 ? (
                <>

                    {/* <div style={{ display: "flex" }} className="dragTable_header Hunt">
                        {basicData.columns.map((column) => (

                            <div key={column.field} style={{ flex: 1, padding: "8px" }} className="fw-bold">
                                {column.label}
                            </div>
                        ))}
                    </div> */}
                    <div className="huntDragdatatableSelect" >
                        {/* <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        {basicData.rows.length > 0 ? (
                                            basicData.rows.map((row, index) => (
                                                <Draggable
                                                    key={index}
                                                    draggableId={index.toString()}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            className="DragAndDropDiv_Align Hunt fw-bold w-100"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                                display: "flex",
                                                                ...getItemStyle(
                                                                    snapshot.isDragging,
                                                                    provided.draggableProps.style
                                                                ),
                                                            }}
                                                        >
                                                            {basicData.columns.map((column) => (
                                                                <div
                                                                    key={column.field}
                                                                    className="HuntGroup"
                                                                >
                                                                    {row[column.field]}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))
                                        ) : (
                                            <div className="no-results-message text-center">
                                                No matching results found
                                            </div>
                                        )}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext> */}

                        <MDBTable align='middle'>
                            <MDBTableHead>
                                <tr>
                                    {basicData.columns.map((column) => (
                                        <th key={column.field}>{column.label}</th>
                                    ))}
                                </tr>
                            </MDBTableHead>
                            <DndContext
                                sensors={sensors}
                                collisionDetection={closestCenter}
                                onDragEnd={handleDndKitDragEnd}
                            >
                                <SortableContext
                                    items={basicData.rows.map((_, index) => index.toString())}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <MDBTableBody>
                                        {basicData.rows.length > 0 ? (
                                            basicData.rows.map((row, index) => (
                                                <SortableItem
                                                    key={index}
                                                    id={index.toString()}
                                                    row={row}
                                                    columns={basicData.columns}
                                                />
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={basicData.columns.length} className="text-center">
                                                    No matching results found
                                                </td>
                                            </tr>
                                        )}
                                    </MDBTableBody>
                                </SortableContext>
                            </DndContext>
                        </MDBTable>



                    </div>
                </>
            ) : (
                <>
                 <div style={{ width: "306px" }}>
                        <MDBInputGroup className="w-100" textAfter={<MDBIcon fas icon="search" />}>
                            <input
                                type="text"
                                className="form-control w-100"
                                placeholder="Search"
                                ref={searchRef}
                                onChange={(e) => {
                                    handleSerach(e.target.value);
                                }}
                            />
                        </MDBInputGroup>
                    </div>
                
                    <div className="actionbar">
                    </div>
                    <MDBDatatable    key={searchValue} className={`text-left actioncolumn top-15Icon callerID-DataTable ${isSequentialGroup === 3 ? "sort-icon" : ""}`}
                        // search
                        sortField="Name"
                        data={basicData}
                        fixedHeader
                        entries={50}
                    />
                </>
            )}
            {isdirtyFields && (
                <SaveChanges
                    onClose={onCloseChanges}
                    onSave={(e) => {
                        e.preventDefault();
                        handleSubmit(onSaveChanges)();
                    }}
                />
            )}
            {/* </form > */}
            {addUsers && (
                <PopupLoaderNew
                    title={t("addusers")}
                    content={<AddToUsers
                        onClose={closeTogglePopup}
                        selectedUsers={groupUsers}
                        setUpdateUsers={setUpdateUsers}
                        setIsAddedUsers={setIsAddedUsers}
                        sourceUsers={sourceUsers}
                        allowDuplicate={true}
                        ref={addUserRef}
                        setIsloading={setisLoading}

                    />}
                    onShow={setAddUsers}
                    onClose={closeTogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )
            }
            {
                isdelete && (
                    <PopupLoaderNew
                        title={"Remove User"}
                        content={
                            <RemoveToUser
                                setIsDeleteUser={setIsDeleteUser}
                                onClose={dtogglePopup}
                                ref={addUserRef}
                                setIsloading={setisLoading}

                            />
                        }
                        onShow={setIsDelete}
                        onClose={dtogglePopup}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={4}
                    />
                )
            }
            {
                isExtdelete && (
                    <PopupLoaderNew
                        title={"Remove External Number"}
                        content={
                            <RemoveExternal
                                setIsDeleteExt={setIsDeleteExt}
                                onClose={dExtogglePopup}
                                ref={addUserRef}
                                setIsloading={setisLoading}

                            />
                        }
                        onShow={setIsExtDelete}
                        onClose={dExtogglePopup}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={4}
                    />
                )
            }

            {
                usersUpdated && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="success"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setUsersUpdated(false)}
                    >
                        <i className="fas fa-check-circle me-3"></i>
                        <span className="alert-msg">{message}</span>
                    </MDBAlert>
                )
            }
            {
                internalError && (<MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >Internal Server Error</MDBAlert>)
            }

            <div className="addExternal-popupwidth">
                {AddExternalNumber && (
                    <PopupLoaderNew
                        size="sm"
                        className="modal-sm"
                        title={t("addExternal")}
                        content={
                            <AddExterNum
                                setExDetails={setExDetails}
                                setExUpdate={setExUpdate}
                                onClose={toggleShow15}
                                externError={externError}
                                setExternError={setExternError}
                                callerids={callerids}
                                calleridFlag={calleridFlag}
                                ref={addUserRef}
                                setIsloading={setisLoading}
                            />
                        }
                        onShow={setAddExternalNumber}
                        onClose={toggleShow15}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={1}
                    />
                )}
            </div>
            {
                isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )
            }
            {editWarning && (
                <PopupLoader
                    size="md"
                    title="Warning"
                    content={
                        <ToggleEditWarning
                            handleUpdateToggle={handleUpdateToggle}
                            handleCloseWarning={handleCloseWarning}
                            toggleValue={toggleValue}
                            columnName="Include User's External Numbers"
                        />
                    }
                    onShow={seteditWarning}
                    onClose={handleCloseWarning}
                />
            )}
            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
            {unSavedWarning && (
                <PopupLoader
                    size="md"
                    className="modal-xl modal-auto"
                    title="Warning"
                    content={
                        <>
                            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                                <MDBIcon
                                    fas
                                    icon="exclamation-triangle"
                                    className="me-3 fs-5 mt-1"
                                    color="warning"
                                />
                                <div>There are unsaved changes. Click <b>OK</b> to proceed without saving or <b>Cancel</b> to remain on the current page.</div>
                            </div>
                            <MDBModalFooter>
                                <MDBBtn color="secondary" onClick={(e) => unsavedWarningToggle()}>{t("cancel")}</MDBBtn>
                                <MDBBtn onClick={(e) => handleUnsavedOk()}>{t("ok")}</MDBBtn>
                                {/* <MDBBtn onClick={(e) => unsavedWarningToggle()}>{t("ok")}</MDBBtn> */}
                            </MDBModalFooter>
                        </>
                    }
                    onShow={setUnsavedWarning}
                    onClose={unsavedWarningToggle}
                />
            )}

            <Tooltip anchorSelect=".ShowVoicemailTooltip" place="top" className="exampleTooltipLight w-20">
                This option is locked for users with Supervisory privileges and cannot be turned off.
            </Tooltip>
        </>
    );


}
export default UsersAndPhonNumbers;